import script from "./BlogPostCardComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogPostCardComponent.vue?vue&type=script&setup=true&lang=js"

import "./BlogPostCardComponent.vue?vue&type=style&index=0&id=1ae48f8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ae48f8c"]])

export default __exports__